import API from '../api/index';
import { DiasHorario, FormatoExportacion, IAyudasJornada, ICorreccion, TipoFichaje } from '../types/Jornada';

const getConfig = () => API.get('/jornada/config');
const updateModulo = (activo: boolean) => API.patch('/jornada/modulo', { activo });
const updatePersona = (especialistaId: number, ficha: boolean) => API.patch(`/jornada/personas/${especialistaId}`, { ficha });
const updateAyudas = (ayudas: IAyudasJornada) => API.patch('/jornada/ayudas', ayudas);
const updatePausas = (pausas: boolean) => API.patch('/jornada/pausas', { pausas });

const getHorarios = () => API.get('/jornada/horarios');
const getHorariosPersona = (especialistaId: number) => API.get(`/jornada/horarios/${especialistaId}`);
const guardarHorario = (especialistaId: number, desde: string, dias: DiasHorario) => API.post(`/jornada/horarios/${especialistaId}`, { desde, dias });
const borrarHorario = (id: string) => API.delete(`/jornada/horarios/${id}`);
const getHorariosAgenda = () => API.get('/jornada/horarios-agenda');

const getEstado = () => API.get('/jornada/estado');
// Sin hora, la del servidor; con hora (ISO), hora declarada de hoy o de ayer
const fichar = (tipo: TipoFichaje, hora?: string) => API.post('/jornada/fichar', hora ? { tipo, hora } : { tipo });
const deshacer = (eventoId: string) => API.post(`/jornada/deshacer/${eventoId}`);
const getMisFichajes = (desde: string, hasta: string) => API.get('/jornada/mis-fichajes', { params: { desde, hasta } });

const getHoy = () => API.get('/jornada/hoy');
const getRegistros = (mes: string) => API.get('/jornada/registros', { params: { mes } });
// PDF, CSV de resumen diario o CSV completo del mes. Con propio, lo de quien exporta (Mis fichajes); si no, el admin exporta
// la persona indicada o, sin ella, todo el equipo. Quien no es admin siempre saca lo suyo.
const exportar = (mes: string, formato: FormatoExportacion, destino: { propio: true } | { especialistaId?: number }) =>
    API.get<Blob>('/jornada/exportar', {
        params: { mes, formato, ...('propio' in destino ? { propio: 1 } : destino.especialistaId !== undefined ? { especialistaId: destino.especialistaId } : {}) },
        responseType: 'blob',
    });
const corregir = (correccion: ICorreccion) => API.post('/jornada/correcciones', correccion);

const JornadaService = {
    getConfig,
    updateModulo,
    updatePersona,
    updateAyudas,
    updatePausas,
    getHorarios,
    getHorariosPersona,
    guardarHorario,
    borrarHorario,
    getHorariosAgenda,
    getEstado,
    fichar,
    deshacer,
    getMisFichajes,
    getHoy,
    getRegistros,
    exportar,
    corregir,
};

export default JornadaService;
